module.exports = __webpack_public_path__ + "static/media/NeuzeitGro-Lig.25e6f0eb.otf";